import { Field, FieldControllerType } from '@gemini/lux-ds-pms';
import { ContactDetailsInfo, Patient } from '@store/patientStore';
import { mergeObjects } from '@utils/functions';
// import { Field } from '@gemini/lux-ds-pms';

export type NestedObject = {
  [key: string]: string | NestedObject | undefined | boolean;
};

export function flattenFields(
  fields: Field[],
  patient: Patient | ContactDetailsInfo,
  prevRes?: NestedObject,
): NestedObject {
  const res = prevRes || {};
  fields.forEach(field => {
    generateObjFromId(field.id, res, !field.children, field.type);
    if (field.children) {
      flattenFields(field.children, patient, res);
    }
  });
  return mergeObjects(res, patient, false);
}

const generateObjFromId = (
  id: string,
  res: NestedObject,
  setValue: boolean,
  type: FieldControllerType,
) => {
  if (id) {
    const ids = id.split('.');
    // entro dentro l'oggetto
    if (ids.length > 1) {
      // console.log('#id', res, ids[0], id);
      if (!Object.prototype.hasOwnProperty.call(res, ids[0])) {
        res[ids[0]] = {};
      }
      const newIds = ids.slice(1);
      generateObjFromId(
        newIds.join('.'),
        res[ids[0]] as NestedObject,
        setValue,
        type,
      );
    } else {
      if (typeof res === 'object' && setValue) {
        res[ids[0]] =
          type === FieldControllerType.CHECKBOX ||
          type === FieldControllerType.TOGGLE
            ? false
            : '';
      }
    }
  }
};
